import React from "react"
import PropTypes from "prop-types"

const AddCircleIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <circle fill={"currentColor"} cx="10" cy="10" r="10" />
      <path d="M10 5v10M5 10h10" stroke="#FFF" strokeWidth="2" strokeLinecap="round" />
    </g>
  </svg>
)

AddCircleIcon.propTypes = {
  style: PropTypes.object
}

export default AddCircleIcon



// WEBPACK FOOTER //
// ./src/components/icons/add-circle-icon.jsx